import usePersistedState from 'hooks/usePersistedState';
import { useCallback, useEffect } from 'react';

function useSearchHistory() {
  const [records, setRecords] = usePersistedState([], 'search-history');

  useEffect(() => {
    const sorted = records.sort((a, b) => b.date - a.date).slice(0, 5);
    if (JSON.stringify(sorted) !== JSON.stringify(records)) {
      setRecords(sorted);
    }
  }, [records]);

  const add = useCallback((text) => {
    const record = records.find((r) => r.text === text);
    if (record) {
      setRecords([
        ...records.filter((r) => r.text !== text),
        { text, date: Date.now() },
      ]);
    } else {
      setRecords([
        ...records,
        { text, date: Date.now() },
      ]);
    }
  }, [records]);

  const remove = useCallback((text) => {
    setRecords((current) => current.filter((r) => r.text !== text));
  }, []);

  return { remove, add, records };
}
export default useSearchHistory;
